import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ToastNotification, Link } from 'carbon-components-react';
import { APP_URL } from 'types';
import { removeAlert } from 'redux/session/actions';
import {
  selectAlerts,
  selectorAlertNotificationShowHide
} from 'redux/session/selectors';

const ToastAlerts: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const alerts = useSelector(selectAlerts);
  const alertNotificationToggle = useSelector(
    selectorAlertNotificationShowHide
  );

  const onClickAction = () => {
    history.push(`${APP_URL.SETTINGS}?tab=profile#dbydLinkingStatus`);
  };

  return (
    <div
      className={`toast-container${alerts.length > 0 ? ' has-alert' : ''}
      ${alertNotificationToggle ? 'noti-alert-notification-toast' : ''}
    `}
    >
      {alerts
        .filter((alert: any) => alert.type !== 'inline')
        .reverse()
        .map((alert: any) => {
          const { id, kind, message, isSystemAlert, timeout } = alert;
          let { details } = alert;
          if (isSystemAlert) {
            details = (
              <div>
                {details}
                <br />
                <br />
                <Link onClick={() => onClickAction()}>
                  {details.indexOf('was changed') !== -1
                    ? 'Update email'
                    : 'Link BYDA account'}
                </Link>
              </div>
            );
          }
          return (
            <ToastNotification
              key={id}
              kind={kind}
              title={message}
              subtitle={details}
              className={isSystemAlert ? 'system-alert' : 'normal-alert'}
              timeout={timeout}
              onCloseButtonClick={() => dispatch(removeAlert(id))}
            />
          );
        })}
    </div>
  );
};

ToastAlerts.displayName = 'LodgeEnquiryToastAlerts';

export default React.memo(ToastAlerts);
